export default "__VITE_ASSET__BB12WYq7__"